












import Vue from 'vue';
import Component from 'vue-class-component';
import IntersectionDirective from '../../common/vue/intersection-directive';

const WordFade = () => import('../../common/vue/WordFade.vue');

const HeadlineAndCopyProps = Vue.extend({
  props: {
    headline: String,
    headlineTag: {
      type: String,
      default: 'h2',
    },
    useSmallHeadline: Boolean,
    text: String,
    alignment: {
      type: String,
      default: 'left',
      validator: (val) => ['left', 'right', 'center'].includes(val),
    },
    bgColor: {
      type: String,
      default: 'black',
    },
    spacingBottom: Boolean,
    spacingTop: Boolean,
  },
});

@Component({
  components: {
    WordFade,
  },
  directives: {
    intersect: IntersectionDirective,
  },
})
export default class HeadlineAndCopy extends HeadlineAndCopyProps {
  get rootClasses () {
    return {
      'brandhub-headline-and-copy--background-white': this.bgColor === 'background-white',
      'brandhub-headline-and-copy--background-black': this.bgColor === 'background-black',
      'brandhub-headline-and-copy--background-theme': this.bgColor === 'background-theme',
      'brandhub-headline-and-copy--alignment-center': this.alignment === 'center',
      'brandhub-headline-and-copy--alignment-left': this.alignment === 'left',
      'brandhub-headline-and-copy--alignment-right': this.alignment === 'right',
      'brandhub-headline-and-copy--spacing-bottom': this.spacingBottom,
      'brandhub-headline-and-copy--spacing-top': this.spacingTop,
      'brandhub-headline-and-copy--small': this.useSmallHeadline,
    };
  }
}
